import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback, useEffect } from "react";
import getProfilePictureUploadUrl, { ProfilePictureUploadUrl } from "../getProfilePictureUploadUrl";

const useGetProfilePictureUploadUrl = (autoSend?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } =
    useRequestState<ProfilePictureUploadUrl | null>(null);

  const send = useCallback(async () => {
    setLoading();
    try {
      const profilePictureUploadUrl = await getProfilePictureUploadUrl();
      return setSuccess(profilePictureUploadUrl);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [setError, setLoading, setSuccess]);

  useEffect(() => {
    if (autoSend) send();
    // prevents infinite loop
    // eslint-disable-next-line
  }, [autoSend]);

  return { ...reqState, data: reqState.data, send };
};

export default useGetProfilePictureUploadUrl;
